import { render, staticRenderFns } from "./general-ledger-v3.vue?vue&type=template&id=d35f118a&scoped=true&"
import script from "./general-ledger-v3.vue?vue&type=script&lang=js&"
export * from "./general-ledger-v3.vue?vue&type=script&lang=js&"
import style0 from "./general-ledger-v3.vue?vue&type=style&index=0&id=d35f118a&scoped=true&lang=css&"
import style1 from "./general-ledger-v3.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d35f118a",
  null
  
)

export default component.exports